export default __webpack_public_path__ + "static/media/malaysia2.4a62ca4a.jpg";